export const API_BASE_URL =
  "https://api.motoswipe.co.uk/api/v1";

